import { Component, EventEmitter, Output, input } from '@angular/core';
import { ICategory, DoodProductModel } from '@core/models/product.model';
import { CategoryKeys } from '@config/keys/category.keys';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';

@Component({
  selector: 'app-product-category-cards-without-name-atom',
  templateUrl: './product-category-cards-without-name-atom.component.html',
})
export class ProductCategoryCardsWithoutNameAtomComponent {
  readonly displayContext = input('');
  readonly category = input.required<ICategory>();
  readonly products = input.required<DoodProductModel[]>();
  readonly tagColors = input.required<ContentBuilderFieldColors>();
  @Output() navigateTo = new EventEmitter<DoodProductModel>();

  categoryKeys = CategoryKeys;

  onNavigateTo(product: DoodProductModel): void {
    this.navigateTo.emit(product);
  }
}
